import { forwardRef } from 'react';
import styles from './Results.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export const Results = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    'aria-label': ariaLabel,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("section", {
    "aria-label": ariaLabel,
    className: styles.results,
    ref: ref,
    ...rest,
    children: children
  });
});